<template>
  <div class="home">
    <div style="" v-if="banner_home">
      <ith-sad-home :img="banner_home.imageUrl" :link="banner_home.hyperlink" />
    </div>

    <ith-top-bar />
    <div class="separate"></div>
    <ith-banner-search-platform />
    <div style="" class="content" v-if="banner_top">
      <ith-sad-top :img="banner_top.imageUrl" :link="banner_top.hyperlink" />
    </div>

    <ith-submenu />
    <ith-grid-movies />
    <ith-grid-articles />
    <ith-must-watch-recommended-lists />
    <div style="" v-if="banner_footer">
      <ith-sad-bottom
        :img="banner_footer.imageUrl"
        :link="banner_footer.hyperlink"
      />
    </div>

    <ith-footer />
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: mapState(["params", "generalCriteria", "paramsMovies", "banners"]),

  name: "Home",
  metaInfo: {
    title:
      "OTT Watchlist - Track Movies, TV Shows From OTT Platforms To Binge Watch",
    meta: [
      {
        name: "description",
        content:
          "Track movies watched and TV Shows with OTT Watchlist. Get access to the top movies and organize your watchlist with the best popular TV shows to binge-watch.",
      },
      {
        name: "keywords",
        content:
          "OTT Watchlist, Track movies watched, TV Shows, binge watch, top movies, best popular TV shows, best web series.",
      },
    ],
  },

  data: () => ({
    user: [],
    banner_top: null,
    banner_footer: null,
    banner_home: null,
  }),
  created() {
    this.getBanner();
  },
  mounted() {
    this.$store.commit("DISABLED_MENU");
    if (
      this.generalCriteria == "" &&
      this.paramsMovies.imdbRange == "" &&
      this.paramsMovies.genres == "" &&
      this.paramsMovies.platforms == "" &&
      this.paramsMovies.sortBy == "" &&
      this.paramsMovies.languages == ""
    ) {
      this.$store.dispatch("FETCH_MOVIES_DEFAULT");
      this.$store.dispatch("FETCH_SERIES_DEFAULT");
    }
    this.$store.dispatch("FETCH_CANT_WATCH_WATCHLIST");
  },
  watch: {
    banners() {
      if (this.banners) this.getBanner();
    },
  },

  methods: {
    getBanner() {
      if (this.banners)
        this.banners.forEach((el) => {
          if (el.page == "home" && el.position == "top") this.banner_top = el;
          else if (el.page == "home" && el.position == "bottom")
            this.banner_footer = el;
          else if (el.page == "home" && el.position == "main") {
            if (
              document.cookie.replace(
                /(?:(?:^|.*;\s*)banner=\s*([^;]*).*$)|^.*$/,
                "$1"
              ) != "main"
            ) {
              this.banner_home = el;
              document.cookie = `banner=main;max-age=600`;
            }
          }
        });
    },
  },
};
</script>

<style scoped>
.home {
  background-color: #2c3848;
}
.separate {
  height: 100px;
}
</style>
